import { useRef, useState } from 'react'

import { EMPTY_OBJECT } from '../../constants/common'

import { RESEND_TIMER_DEFAULT_SECONDS } from './useResendTimer.constants'

export function useResendTimer({
  initialSeconds = RESEND_TIMER_DEFAULT_SECONDS,
} = EMPTY_OBJECT) {
  const [secondsLeft, setSecondsLeft] = useState(initialSeconds)
  const [finished, setFinished] = useState(false)

  const intervalRef = useRef(null)

  function handleClearInterval() {
    setFinished(false)

    if (intervalRef.current) {
      clearInterval(intervalRef.current)
      intervalRef.current = null
    }
  }

  function start() {
    handleClearInterval()

    setFinished(false)

    setSecondsLeft(initialSeconds)

    intervalRef.current = setInterval(() => {
      setSecondsLeft(prev => {
        if (prev <= 1) {
          handleClearInterval()
          setFinished(true)

          return 0
        }

        return prev - 1
      })
    }, 1000)
  }

  function reset() {
    handleClearInterval()
    setSecondsLeft(initialSeconds)
  }

  return {
    isFinished: finished,
    reset,
    secondsLeft,
    start,
    stop: handleClearInterval,
  }
}
